import Header from "../../components/public/header";
import Navigation from "../../components/public/navigation";
import Main from "../../components/public/sections/main";
import Founder from "../../components/public/founder";
import Footer from "../../components/public/footer";

export default () => {
  return (
    <>
      <Navigation />
      <Header />
      <Main pageHeading={"मंडळ संस्थापक"} content={<Founder />} />
      <Footer />
    </>
  );
};
